var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import FilledInput from '@mui/material/FilledInput';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputAdornment from '@mui/material/InputAdornment';
import { colorPalette } from '../../colorPalette';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Visibility from '@mui/icons-material/Visibility';
import InputLabel from '@mui/material/InputLabel';
import IconButton from '@mui/material/IconButton';
export const PasswordField = (props) => {
    const { dataQa, label, helperText, error } = props, rest = __rest(props, ["dataQa", "label", "helperText", "error"]);
    const [showPassword, setShowPassword] = useState(false);
    const handleShowPassword = () => {
        setShowPassword(!showPassword);
    };
    return (React.createElement(FormControl, { variant: "filled", "data-qa": dataQa ? dataQa : 'passwordfield-core' },
        label && React.createElement(InputLabel, null, label),
        React.createElement(FilledInput, Object.assign({}, rest, { error: error, type: showPassword ? 'text' : 'password', endAdornment: React.createElement(InputAdornment, { position: "end" },
                React.createElement(IconButton, { onClick: handleShowPassword }, showPassword ? (React.createElement(VisibilityOff, { style: { color: colorPalette.gray700 } })) : (React.createElement(Visibility, { style: { color: colorPalette.gray700 } })))) })),
        React.createElement(FormHelperText, { error: error }, helperText)));
};
